import ItemId from 'owa-service/lib/contract/ItemId';
import acceptSharedCalendarInviteOperation from 'owa-service/lib/operation/acceptSharedCalendarInviteOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import AcceptSharedCalendarInviteResponseMessage from 'owa-service/lib/contract/AcceptSharedCalendarInviteResponseMessage';

export default function acceptSharedCalendarInvite(
    messageId: ItemId
): Promise<AcceptSharedCalendarInviteResponseMessage> {
    return acceptSharedCalendarInviteOperation({
        Header: getJsonRequestHeader(),
        Body: {
            MessageId: messageId,
        },
    }).then(response => {
        return response.Body;
    });
}
